export default __webpack_public_path__ + "static/media/question001_answer_user001.80171c48.png";